import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3a3eb6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component pagenation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 18L5 12L11 6L12.4 7.4L7.825 12L12.4 16.6L11 18ZM17.6 18L11.6 12L17.6 6L19 7.4L14.425 12L19 16.6L17.6 18Z",
    fill: "#ffffff"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z",
    fill: "#ffffff"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z",
    fill: "#ffffff"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.575 12L5 7.4L6.4 6L12.4 12L6.4 18L5 16.6L9.575 12ZM16.175 12L11.6 7.4L13 6L19 12L13 18L11.6 16.6L16.175 12Z",
    fill: "#ffffff"
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["arrow-box", { active: _ctx.currPage>1 }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.movePage(1)))
    }, _hoisted_3, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["arrow-box", { active: _ctx.startPage > 1 }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.movePage(_ctx.startPage - 1)))
    }, _hoisted_5, 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["page-box", { active: idx === _ctx.currPage }]),
        key: idx,
        onClick: ($event: any) => (_ctx.movePage(idx))
      }, [
        _createElementVNode("h3", null, _toDisplayString(idx), 1)
      ], 10, _hoisted_6))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass(["arrow-box", { active: _ctx.endPage < _ctx.totalPage }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.movePage(_ctx.endPage + 1)))
    }, _hoisted_8, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["arrow-box", { active: _ctx.currPage < _ctx.totalPage }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.movePage(_ctx.totalPage)))
    }, _hoisted_10, 2)
  ]))
}